export default {
    message: "Os itens listados abaixo estão em falta e foram removidos do seu carrinho. Faça seleções diferentes.",
    buttons: {
        ok: "Ok"
    }
}